import React, { createContext, useContext, useState, useEffect } from "react";
import { useAuth0 } from "@auth0/auth0-react";

// Función utilitaria para decodificar JWT
const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error("Error decoding JWT", e);
    return null;
  }
};

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const { user, isAuthenticated, getAccessTokenSilently, isLoading, loginWithRedirect } = useAuth0();
  const [userProfile, setUserProfile] = useState(null);
  const [loadingProfile, setLoadingProfile] = useState(true);

  useEffect(() => {
    const getUserProfile = async () => {
      
      console.log(isAuthenticated, user);

      if (isAuthenticated && user) {
        try {
          const accessToken = await getAccessTokenSilently({
            authorizationParams: {
              audience: "https://api.ajedrezpensado.com"
            },
          });

          // Decodificamos el access token
          const decodedToken = parseJwt(accessToken);
          
          if (decodedToken) {
            const profileData = {
              ...user, // Conservamos los datos básicos del usuario proveídos por useAuth0 (email, nickname, etc)
              sub: decodedToken.sub,
              permissions: decodedToken.permissions || []
            };
            console.log("Decoded Profile Data:", profileData);
            setUserProfile(profileData);
          } else {
            // Fallback en caso de que falle la decodificación
            setUserProfile(user);
          }
        } catch (error) {
          console.error("Error obteniendo o decodificando el access token:", error);
          
          const errorMessage = error.message || String(error);
          if (errorMessage.includes("Missing Refresh Token") || error.error === "login_required" || error.error === "consent_required") {
            // Initiate a silent redirection to solve the broken session
            console.log("Redirigiendo a login...");
            await loginWithRedirect({
              appState: { returnTo: window.location.pathname }
            });
            return; // Wait for redirect, keeping loadingProfile true
          }
          
          // Fallback para otros errores para evitar que la app quede congelada sin userProfile
          setUserProfile(user);
        }
        
        setLoadingProfile(false);
      } else if (!isLoading && !isAuthenticated) {
        setLoadingProfile(false);
      }
    };

    getUserProfile();
  }, [isAuthenticated, user, getAccessTokenSilently, isLoading, loginWithRedirect]);

  return <UserContext.Provider value={{ userProfile, loadingProfile }}>{children}</UserContext.Provider>;
};